import React from 'react';

import { Container, TextAreaStyled } from './TextArea.styled';
import { V2_COMPONENT_CLASS_NAME } from 'components/v2/common.styled';
import { getInputStates } from 'components/v2/utils';

import { Props } from './TextArea.types';

export const TextArea = ({
  id,
  helperTextId,
  labelId,
  status = 'default',
  placeholder,
  required = false,
  spellCheck = false,
  value,
  onChange,
  onBlur,
  onKeyPress,
  onKeyDown,
  onFocus,
  className,
  fullWidth,
  backgroundColor,
  ariaLabel,
  height,
  rows,
  maxLength
}: Props) => {
  const isFilled = Boolean(value);
  const { isDisabled, isReadOnly, isValid } = getInputStates(status);

  return (
    <Container className={className} fullWidth={fullWidth}>
      <TextAreaStyled
        className={V2_COMPONENT_CLASS_NAME}
        id={id}
        status={status}
        $isFilled={isFilled}
        disabled={isDisabled}
        placeholder={placeholder}
        spellCheck={spellCheck}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        onKeyPress={onKeyPress}
        onKeyDown={onKeyDown}
        onFocus={onFocus}
        required={required}
        aria-labelledby={labelId}
        aria-disabled={isDisabled}
        aria-invalid={!isValid}
        aria-readonly={isReadOnly}
        aria-errormessage={helperTextId}
        backgroundColor={backgroundColor}
        aria-label={ariaLabel}
        height={height}
        rows={rows}
        maxLength={maxLength}
      />
    </Container>
  );
};
